export const workAssignmentDetailsTooltipText = {
	assignedCrewMember: 'Assigned Crew Member:',
	noCrewMember: 'No crew member assigned',
	route: 'Route:',
	line: 'Line:',
	tripNumber: 'Trip Number:',
	uuid: 'UUID: ',
	departure: 'Departure: ',
	rideDetails: 'Ride details',
	arrival: 'Arrival',
	departureTime: 'Departure',
	stations: 'stations',
};
